import { Box } from '@apia/theme';
import { useResponsiveTableContext } from '../ResponsiveTableContext';

const NoRegistersRenderer = () => {
  const { labels } = useResponsiveTableContext();
  return <Box className="no__registers">{labels.noRegisters}</Box>;
};

export default NoRegistersRenderer;
